<template>
  <div>
    <AppBarAdminOrganizer 
      v-if="user.roles.some(role => role === 'admin' || role === 'organizer')" 
    />
    
    <AppBarEntrepreneur
      :drawer="drawer" 
      v-if="user.roles.find(role => role === 'entrepreneur')&&!edition.edition.waiting_room" 
    />

    <AppBarEntrepreneurWaitingRoom
      :drawer="drawer" 
      v-if="user.roles.find(role => role === 'entrepreneur')&&edition.edition.waiting_room" 
    />

    <AppBarParticipant
      :drawer="drawer" 
      v-if="user.roles.find(role => role === 'participant')&&!edition.edition.waiting_room" 
    />

    <AppBarParticipantWaitingRoom 
      :drawer="drawer" 
      v-if="user.roles.find(role => role === 'participant')&&edition.edition.waiting_room" 
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AppBarAdminOrganizer from './AppBar/AppBarAdminOrganizer.vue'

import AppBarEntrepreneur from './AppBar/AppBarEntrepreneur.vue'
import AppBarEntrepreneurWaitingRoom  from './AppBar/AppBarEntrepreneurWaitingRoom.vue'

import AppBarParticipant from './AppBar/AppBarParticipant.vue'
import AppBarParticipantWaitingRoom from './AppBar/AppBarParticipantWaitingRoom.vue'

export default {
  name: 'AppBar',
  components: {
    AppBarAdminOrganizer, 
    
    AppBarEntrepreneur,
    AppBarEntrepreneurWaitingRoom,
    
    AppBarParticipant,
    AppBarParticipantWaitingRoom
  },
  data: () => ({
    loading: false,
  }),

  computed: {
    ...mapGetters([
      'user', 'edition', 'drawer'
    ]),

    drawer: {
      get() {
        return this.$store.getters.drawer;
      },
      set(value) {
        this.$store.commit('setDrawer', value);
      },
    },

  }
}
</script>